module.exports = __webpack_public_path__ + "1b0b038565bbf20e793173f37d5ca101.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/landing-page/news-popup/news-popup.html
// module id = 1460
// module chunks = 0